var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dashboard-section',{attrs:{"section":_vm.section,"loading":_vm.loading,"error":_vm.error,"loading-text":"Loading your account organization…","empty-text":_vm.emptyText},on:{"retry":_vm.fetchOrganization}})}
var staticRenderFns = []

export { render, staticRenderFns }